import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv } from '../TextStyle'
import { codeItems, codeLinks } from './CodeItems'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Index } from '@/components/enlayouts/Legal/Index'
import { SectionTitle } from '@/components/enlayouts/Legal/SectionTitle'

const sectionTitle = {
  children: <h2>Code of Conduct</h2>,
}

export const CodePage = () => {
  return (
    <>
      <Head
        title="Code of Conduct"
        description="The image polidy for TRIAL Holdings, Inc."
        ogp={{ type: 'article', url: 'en/legal/code/' }}
      />
      <CodeContainer>
        <SectionTitle {...sectionTitle} />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <Index columnGap={64} listType="article" links={codeLinks} />
        <Spacer h={{ pc: 70, sp: 39 }} />
        {codeItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < codeItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </CodeContainer>
    </>
  )
}
CodePage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Legal', path: '/en/legal/' },
    { name: 'Code Of Conduct', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const CodeContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }
`
